<template>
    <div class="table-wrapper" style="padding-top: 30px">
        <div class="fchart-wrapper" style="margin-bottom: 24px;">
            <div class="aFlex fchart-top">
                <span class="ft-bold">请选择统计时间：</span>
                <DatePicker style="width: 180px;" type="month" placement="bottom-end" transfer placeholder="请选择" :value="dateMonth" @on-change="onDateMonth" ></DatePicker>
                <Select style="width: 160px; margin-left: 16px" v-model="areaCode" @on-change='changeLine1' placeholder="选择地区" clearable>
                    <Option v-for="item in area" :value="item.value" :key="item.value" >{{ item.label }}</Option>
                </Select>
            </div>
            <Row :gutter="24">
                <Col span="12">
                    <div class="fchart-box" style="margin-bottom: 0">
                        <payoffPie ref="payoffPie" :areaCode="areaCode" :dateMonth="dateMonth"></payoffPie>
                    </div>
                </Col>
                <Col span="12">
                    <div class="fchart-box" style="margin-bottom: 0">
                        <payProject ref="payProject" :areaCode="areaCode" :dateMonth="dateMonth"></payProject>
                    </div>
                </Col>
            </Row>
        </div>
        <div class="fchart-box">
            <salaryBar></salaryBar>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import payProject from './components/payProject';
    import payoffPie from './components/payoffPie';
    import salaryBar from './components/salaryBar';
    export default {
        data(){
            return {
                areaCode: localStorage.getItem('tenantAreaCode'),
                dateMonth:'',
                dateYear:'',
            };
        },
        components:{
            payoffPie,
            payProject,
            salaryBar,
        },
        computed: {
            ...mapState(['area']),
        },
        watch: {

        },
        created(){
        },
        mounted(){

        },
        methods: {
            // 第一行 <
            // 地区改变
            changeLine1(e) {
                this.areaCode = e || localStorage.getItem('tenantAreaCode');
                this.$nextTick(() => {
                    this.$refs.payoffPie.getData();
                    this.$refs.payProject.getData();
                })
            },
            // 月份改变
            onDateMonth(e){
                this.dateMonth=e;
                this.$nextTick(() => {
                    this.$refs.payoffPie.getData();
                    this.$refs.payProject.getData();
                })
            },
        }
    };
</script>
